import { i18n } from '@shared/i18n';
import IdField from '@shared/fields/id-field';
import DateTimeRangeField from '@shared/fields/date-time-range-field';
import DateTimeField from '@shared/fields/date-time-field';
import { GenericModel } from '@shared/model/generic-model';
import StringField from '@shared/fields/string-field';
import DateModelField from '@shared/fields/date-model-field';
import BooleanField from '@shared/fields/boolean-field';
import FilesField from '@shared/fields/files-field';
import EnumeratorField from '@shared/fields/enumerator-field';
import getSharedEnumeratorField from '@shared/fields/helpers/getSharedEnumeratorField';

function label(name) {
    return i18n(`entities.inscription.fields.${name}`);
}

const fields = (propertyName, dateFormat) => ({
    id: new IdField('id', label('id')),
    status: new EnumeratorField('status', label('status'), getSharedEnumeratorField('inscriptionStatus'), { required: true }),
    user: new StringField('user', label('user'), {
        "required": true
    }),
    name: new StringField('name', label('name'), {}),

    firstName: new StringField('firstName', label('firstName'), {
        "required": true
    }),
    lastName: new StringField('lastName', label('lastName'), {
        "required": true
    }),
    birthdate: new DateModelField('birthdate', label('birthdate'), {
        "required": true,
        onlyPastDate: true,
        dateFormat
    }),
    gender: new EnumeratorField('gender', label('gender'), getSharedEnumeratorField('genderBinary'), { required: true }),
    isMember: new BooleanField('isMember', label('isMember').replace('${name}', propertyName), {
        "required": true
    }),
    careerInfo: new StringField('careerInfo', label('careerInfo'), { required: true }),
    identDoc: new StringField('identDoc', label('identDoc'), {
        "required": true
    }),
    identDocFiles: new FilesField(
        'identDocFiles',
        label('identDocFiles'),
        (inscriptionId, userId) => `inscriptions/${inscriptionId}/users/${userId}/identDocFiles`,
        {
            required: true,
            size: 10485760, // 10 MB
            formats: ['image/jpg', 'image/jpeg', 'image/png', 'application/pdf', 'application/x-pdf'],
            max: 4,
        }
    ),
    additionalDocFiles: new FilesField(
        'additionalDocFiles',
        label('additionalDocFiles'),
        (inscriptionId, userId) => `inscriptions/${inscriptionId}/users/${userId}/additionalDocFiles`,
        {
            required: true,
            size: 10485760, // 10 MB
            max: 10,
        }
    ),
    program: new StringField('program', label('program'), {
        "required": true
    }),
    subprogram: new StringField('subprogram', label('subprogram'), {
        "required": true
    }),
    emailParent: new StringField('emailParent', label('emailParent'), {
        "required": true
    }),
    nameParent: new StringField('nameParent', label('nameParent'), {
        "required": true
    }),
    createdAt: new DateTimeField(
        'createdAt',
        label('createdAt'),
    ),
    updatedAt: new DateTimeField(
        'updatedAt',
        label('updatedAt'),
    ),
    createdAtRange: new DateTimeRangeField(
        'createdAtRange',
        label('createdAtRange'),
    ),
    birthdateRange: new DateTimeRangeField(
        'birthdateRange',
        label('birthdateRange'),
    ),
});

export class InscriptionModel extends GenericModel {
    static fields({ propertyName, dateFormat }) {
        return fields(propertyName, dateFormat);
    }
    static presenter(row, fieldName, propertyName, dateFormat) {
        const fields = this.fields({ propertyName, dateFormat });

        if (!fields[fieldName]) {
            throw new Error(`${fieldName} not found`);
        }

        return fields[fieldName].forPresenter(
            row[fields[fieldName].name],
        );
    }
}